import { render } from "./v-report-payment.vue?vue&type=template&id=10026c0a"
import script from "./v-report-payment.vue?vue&type=script&lang=js"
export * from "./v-report-payment.vue?vue&type=script&lang=js"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__